﻿import { Outlet } from 'react-router-dom';
import { useContext, useEffect } from 'react';
import { AuthContext } from '../context/auth-context.ts';
import { AuthVerifyRender } from '../components/render/auth-verify-render.tsx';
import { AuthFailedRender } from '../components/render/auth-failed-render.tsx';
import { login } from '../services/api.ts';

export function ProtectedLayout() {
  const { isLoading, isAuthenticated } = useContext(AuthContext)!;

  const hasRedirected = sessionStorage.getItem('redirected') === 'true';

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !hasRedirected) {
      sessionStorage.setItem('redirected', 'true');
      login();
    }
  }, [isLoading, isAuthenticated, hasRedirected]);

  if (isLoading) {
    return <AuthVerifyRender />;
  }

  if (!isAuthenticated) {
    if (!hasRedirected) {
      return <AuthVerifyRender />;
    }
    return <AuthFailedRender />;
  }

  return <Outlet />;
}
